import axios from 'axios'
import Settings from "../../settings.json";
const url = Settings.isNative ? Settings.frontlineArServer : "";

export class AiRequester {

    static async uploadFile(path, query) {
        const result = await axios.post(`${url}/${path}`,query);
        return result.data;
    }
    static async uploadEmbeddedFiles(db ,associatedFiles, embeddedFiles) {
        const result = await axios.post(`${url}/AiStudioManagement/${db}/SaveFiles`, { associatedFiles, embeddedFiles });
        return result.data;
    }
    static async getInitialValues(workspace) {
        const result = await axios.post(`${url}/AiChatManagement/GetInitValuesAiChat`,{workspace});
        return result.data;
    }
    static async publishPendingChanges(db) {
        const result = await axios.post(`${url}/AiStudioManagement/${db}/PublishFilesChanges`, {});
        return result.data;
    }
    static async discardPendingChanges(db) {
        const result = await axios.post(`${url}/AiStudioManagement/${db}/DiscardFilesChanges`, { });
        return result.data;
    }


}